import { Component, Input, ViewChild } from "@angular/core";
import { CBP3461 } from "../../../../objects/documents/CBP3461";
import { NgForm } from "@angular/forms";

@Component({
    selector: 'certification-info-3461',
    templateUrl: "certification-info-3461.component.html",
    moduleId: module.id.toString()
})
export class CertificationInfo3461Component {
    @Input()
    public document: CBP3461;

    @ViewChild("certificationInfoForm")
    public certificationInfoForm: NgForm;


    public submitFormAndValidity(): boolean {
        this.certificationInfoForm.onSubmit(null);

        return this.isFormValid();
    }

    public isFormValid(): boolean {
        return this.certificationInfoForm.valid;
    }
}


// WEBPACK FOOTER //
// ./app/components/export-documents/cbp-3461/document-blocks/certification-info-3461.component.ts